import {useLocation, useNavigate} from 'react-router-dom';

// project imports
import useAuth from 'hooks/useAuth';
import config from 'config';
import { GuardProps } from 'types';
import { useEffect } from 'react';

// ==============================|| GUEST GUARD ||============================== //

/**
 * Guest guard for routes having no auth required
 * @param {PropTypes.node} children children element/node
 */

const GuestGuard = ({ children }: GuardProps) => {
    const { isLoggedIn } = useAuth();
    const navigate = useNavigate();
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const code = queryParams.get('code'); // '123123'
    console.log("yot")
    useEffect(() => {
        if (isLoggedIn) {
            if(!code) {
                navigate(config.defaultPath, { replace: true });
            } else {
                navigate(config.defaultPath +"/reports/tax-israel"+ '?code=' + code, { replace: true });
            }

        }
    }, [isLoggedIn, navigate]);

    return children;
};

export default GuestGuard;
